import React from 'react';

export const HeaderWrapper = ({ children, style }) => (
  <div
    style={{
      maxHeight: '110px',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'space-between',
      paddingRight: '30px',
      boxShadow: 'rgba(0, 0, 0, 0.05) 10px 10px 20px 0px',
      backgroundColor: '#fff',
      ...style
    }}
  >
    {children}
  </div>
);
